<div class="container">
    <form action="">
        <div>
            <input [(ngModel)]="searchText" id="car" #dictionarySearchInput placeholder="{{placeholder}}"
                class="form-control" type="text" autocomplete="off" (click)="showSearches = true"
                (ngModelChange)="searchTextUpdate.next($event)">

        </div>
    </form>
    <div class="card" style="position:absolute w-100">
        <div class="action">
            <button [hidden]="searchText"><i class="bx bx-search"></i></button>
            <button [hidden]="!searchText"><img src="assets/img/close.png" alt="" (click)="clearSearch()"></button>
        </div>
        <div class="search" [hidden]="!handleShowSearch()">
            <div *ngFor="let item of searchedItems" tappable class="search-result" (click)="onChooseWord(item.id)">
                {{item.displayText}}
            </div>
        </div>
        
    </div>
</div>
